import { render, staticRenderFns } from "./FotonReboton.vue?vue&type=template&id=792266f8&scoped=true"
import script from "./FotonReboton.vue?vue&type=script&lang=js"
export * from "./FotonReboton.vue?vue&type=script&lang=js"
import style0 from "./FotonReboton.vue?vue&type=style&index=0&id=792266f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792266f8",
  null
  
)

export default component.exports